'use client';

import { type ReactNode, useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * Renders `fallback` on the server and during hydration, then `children`. For markup the
 * server cannot send as HTML, because the browser's parser would restructure it and the
 * hydration would fail. A client-side render shows `children` at once.
 */
export function AfterHydration({
  fallback,
  children,
}: {
  fallback: ReactNode;
  children: ReactNode;
}) {
  const hydrated = useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
  return hydrated ? children : fallback;
}
